import { calendarEffects } from './calendar/effect.js';
import { ganttEffects } from './gantt/effect.js';
import { kanbanEffects } from './kanban/effect.js';
import { DataViewHorizontalScrollbar } from './shared/horizontal-scrollbar.js';
import { tableEffects } from './table/effect.js';

export function viewPresetsEffects() {
  customElements.define('dv-horizontal-scrollbar', DataViewHorizontalScrollbar);
  calendarEffects();
  kanbanEffects();
  tableEffects();
  ganttEffects();
}
